export default __webpack_public_path__ + "static/media/June2021.48ba32a1.png";